/**
 * Add-administrator: business-error mapper.
 *
 * Reuses the shared `AdministratorFormError` union but pins the Add-flow default
 * message ("Failed to send invitation."). The `validation` variant is produced
 * by the saga directly; this maps the infra failures (`network` | `api`).
 */
import { classifyInfraError } from '@/utils/infra-error';

import type { AdministratorFormError } from '../../_shared/domain/administrator-form-error';

export type { AdministratorFormError as AddAdministratorError };

export function toAddAdministratorError(e: unknown): AdministratorFormError {
  return classifyInfraError(e, 'Failed to send invitation.');
}
